import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

//navigation
import Navigation from './components/navigation/Navigation';

//screens
import Main from './screens/Main/Main';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Routes>
        <Route path='/' element={<Main />} />
      </Routes>
    </div>
  );
}

export default App;
